import React , { useEffect } from "react";
import Layout from "../../components/Layout";
import Header from "./Header";
import { useTranslation, useLanguageQuery } from "next-export-i18n"
const Index = () => {
  const { t } = useTranslation()
  const [query] = useLanguageQuery()

 //since we are using next export i18n we need to add this useEffect to make sure the html lang attribute is set to the correct language

  useEffect(() => {
    let lang = query?.lang == "fr" ? "fr" : "en"
    document.querySelector("html").setAttribute("lang", lang)
  }, [query])


  return (
    <div>
      <Layout>
        <Header />
      </Layout>
    </div>
  );
};

export default Index;
